export default "__VITE_ASSET__BxzhtvjO__"